<template>
  <div>
    <VpHeaderActions>
      <VpPortalButton
        :icon="$options.icons.Help"
        label="How to Use SEO Variables"
        @click.native="openModal"
      />
    </VpHeaderActions>
    <VpVueForm
      :fields="fields"
      :id="productId"
      :save="save"
      :get="get"
      class="vp-p-6"
      width="500px"
      media-for="seo_og_image"
    >
      <template #default="{ state }">
        <VpField label="Title" name="title">
          <VpInput>
            <VpTextBox v-model="state.title" placeholder="Enter title" />
          </VpInput>
        </VpField>

        <VpField label="Meta Description" name="meta_description">
          <VpTextArea
            v-model="state.meta_description"
            placeholder="Enter meta description"
          />
        </VpField>

        <VpField label="Social Image" optional>
          <VpImageEditor
            id="IMAGE"
            v-model="media"
            #default="{ value }"
            @beforeChange="onMediaDelete($event)"
            @delete="onMediaDelete($event)"
          >
            <VpMedia type="Image" size="96" :value="value" />
          </VpImageEditor>
        </VpField>
      </template>

      <template #footer="{ saveItem, isSaving }">
        <div>
          <VyButton
            label="Save"
            @click.native="saveItem"
            :loading="isSaving"
            class="button--primary button--solid button--md button--rounded"
          />
        </div>
      </template>
    </VpVueForm>
    <ProductSeoInfoModal />
  </div>
</template>

<script>
import { uploadMediaToS3, deleteMedia } from "utils/presets";
import { READ, UPSERT } from "./gql.js";
import { Help } from "icons/icons.js";
import ProductSeoInfoModal from "./_info-modal.vue";

export default {
  icons: {
    Help,
  },
  components: {
    ProductSeoInfoModal,
  },
  props: {
    productId: [Number, String],
  },

  data() {
    return {
      media: {},
      fields: ["title", "meta_description", { name: "og_image", value: null }],
    };
  },

  methods: {
    openModal() {
      this.$vayu.modal.open("product-seo-info-modal");
    },
    get(productId) {
      return this.$query(READ, {
        id: Number(productId),
      }).then(({ data }) => {
        const seo = data.product.seo || {};

        this.media = {
          url: seo.og_image?.url,
          id: seo.og_image?.id,
        };

        return {
          values: {
            title: seo.title,
            meta_description: seo.meta_description,
            og_image: seo.og_image?.id,
          },
        };
      });
    },

    async save(id, data) {
      if (this.media.status == "CHANGE") {
        const uploadData = {
          path: "seo_og_image",
          file: this.media,
        };

        const uploaded = await uploadMediaToS3(uploadData);

        this.media.status = null;
        data.og_image = uploaded.id;
      } else if (this.media.status == "DELETE") {
        data.og_image = null;
      }

      return this.$mutate(UPSERT, {
        id: Number(this.productId),
        input: {
          ...data,
        },
      }).then(({ data }) => data);
    },

    onMediaDelete(data) {
      if (data?.id) {
        deleteMedia([data.id]);
      }
      this.media = {};
      this.media.status = "DELETE";
    },
  },
};
</script>
